module.exports = __webpack_public_path__ + "img/avatar3.47e04ccc.jpg";